module.exports = __webpack_public_path__ + "media/Loops Drums.800d6f20.wav";